import { render, staticRenderFns } from "./Discount.template.vue?vue&type=template&id=075e86cc&scoped=true&"
var script = {}
import style0 from "./Discount.template.vue?vue&type=style&index=0&id=075e86cc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075e86cc",
  null
  
)

export default component.exports